<template>
  <v-form ref="form" v-model="valid">
    <v-row dense>
      <v-col cols="12" md="8">
        <v-text-field
          v-model="formData.title"
          placeholder="VD: Mua sắm 10 bộ máy tính cho phòng Tin học 2..."
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng nhập tiêu đề']"
        >
          <template v-slot:label>
            Tiêu đề đề xuất mua sắm <span class="red--text font-weight-bold">*</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="formData.priority"
          :items="priorityList"
          outlined
          dense
        >
          <template v-slot:label>
            Mức độ ưu tiên <span class="red--text font-weight-bold">*</span>
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.proposer"
          placeholder="Họ tên người đề xuất"
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng nhập người đề xuất']"
        >
          <template v-slot:label>
            Người đề xuất <span class="red--text font-weight-bold">*</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.department"
          placeholder="VD: Tổ Tin học - Ngoại ngữ"
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng nhập phòng ban']"
        >
          <template v-slot:label>
            Tổ / Bộ môn / Phòng ban <span class="red--text font-weight-bold">*</span>
          </template>
        </v-text-field>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="formData.justification"
          placeholder="Nêu rõ lý do cần trang bị sắm mới (VD: Thay thế máy hỏng, phục vụ chương trình mới...)"
          outlined
          dense
          rows="2"
          :rules="[v => !!v || 'Vui lòng nêu lý do']"
        >
          <template v-slot:label>
            Lý do & Mục đích sử dụng <span class="red--text font-weight-bold">*</span>
          </template>
        </v-textarea>
      </v-col>

      <!-- Danh sách mặt hàng đề xuất -->
      <v-col cols="12">
        <v-card outlined class="pa-3 grey lighten-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <span class="text-subtitle-2 font-weight-bold primary--text text-uppercase">
              Danh mục thiết bị / Vật tư đề xuất ({{ formData.items.length }})
            </span>
            <v-btn small color="primary" depressed @click="addItem">
              <v-icon small left>mdi-plus</v-icon> Thêm món
            </v-btn>
          </div>

          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th style="width: 30%">Tên thiết bị / Chủng loại <span class="red--text font-weight-bold">*</span></th>
                  <th style="width: 25%">Quy cách / Cấu hình</th>
                  <th style="width: 15%">Số lượng <span class="red--text font-weight-bold">*</span></th>
                  <th style="width: 15%">Đơn vị</th>
                  <th style="width: 15%">Đơn giá dự kiến</th>
                  <th style="width: 40px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="formData.items.length === 0">
                  <td colspan="6" class="text-center grey--text py-3">
                    Chưa có thiết bị nào. Nhấn "Thêm món" để bắt đầu.
                  </td>
                </tr>
                <tr v-for="(it, idx) in formData.items" :key="idx">
                  <td>
                    <v-text-field
                      v-model="it.name"
                      placeholder="VD: Màn hình Dell 24 inch..."
                      outlined
                      dense
                      hide-details
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="it.specifications"
                      placeholder="FullHD, IPS, 75Hz..."
                      outlined
                      dense
                      hide-details
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model.number="it.quantity"
                      type="number"
                      min="1"
                      outlined
                      dense
                      hide-details
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="it.unit"
                      placeholder="Cái, Bộ..."
                      outlined
                      dense
                      hide-details
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model.number="it.estimatedPrice"
                      type="number"
                      min="0"
                      outlined
                      dense
                      hide-details
                    />
                  </td>
                  <td class="text-center">
                    <v-btn icon small color="error" @click="removeItem(idx)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="formData.note"
          label="Ghi chú thêm"
          outlined
          dense
          rows="2"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { Subject, SubjectGroup } from '@/plugins/api'

export default {
  name: 'ProposalForm',
  data() {
    return {
      valid: true,
      priorityList: [
        { text: 'Thấp', value: 'LOW' },
        { text: 'Bình thường', value: 'MEDIUM' },
        { text: 'Cao', value: 'HIGH' }
      ],
      formData: {
        title: '',
        priority: 'MEDIUM',
        proposer: '',
        department: '',
        justification: '',
        status: 'SUBMITTED',
        note: '',
        proposerUser: null,
        items: []
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['role', 'profile', 'user']),
    isTeacher() {
      return this.role && (this.role.name === 'Teacher' || this.role.type === 'teacher')
    }
  },
  async created() {
    if (this.user) {
      this.formData.proposerUser = this.user.id || this.user._id
    }
    if (this.formData.items.length === 0) {
      this.addItem()
    }
    await this.initProfileData()
  },
  methods: {
    isMongoId(val) {
      return typeof val === 'string' && /^[0-9a-fA-F]{24}$/.test(val)
    },
    async initProfileData() {
      if (!this.profile) return
      this.formData.proposer = this.profile.name || ''

      // 1. Nếu có department dạng tên trực tiếp
      if (this.profile.department) {
        if (typeof this.profile.department === 'string' && !this.isMongoId(this.profile.department)) {
          this.formData.department = this.profile.department
          return
        }
        if (typeof this.profile.department === 'object') {
          const deptName = this.profile.department.title || this.profile.department.name
          if (deptName) {
            this.formData.department = deptName
            return
          }
        }
      }

      // 2. Nếu có subjectGroup (Tổ bộ môn)
      if (this.profile.subjectGroup) {
        if (typeof this.profile.subjectGroup === 'object') {
          const sgName = this.profile.subjectGroup.title || this.profile.subjectGroup.name
          if (sgName) {
            this.formData.department = sgName
            return
          }
        } else if (typeof this.profile.subjectGroup === 'string') {
          if (!this.isMongoId(this.profile.subjectGroup)) {
            this.formData.department = this.profile.subjectGroup
            return
          }
          try {
            const sg = await SubjectGroup.get(this.profile.subjectGroup)
            if (sg && (sg.title || sg.name)) {
              this.formData.department = sg.title || sg.name
              return
            }
          } catch (e) {
            console.error('Error fetching subjectGroup:', e)
          }
        }
      }

      // 3. Nếu có subject (Môn học)
      if (this.profile.subject) {
        if (typeof this.profile.subject === 'object') {
          const subName = this.profile.subject.title || this.profile.subject.name
          if (subName) {
            this.formData.department = `Bộ môn ${subName}`
            return
          }
        } else if (typeof this.profile.subject === 'string') {
          if (!this.isMongoId(this.profile.subject)) {
            this.formData.department = this.profile.subject
            return
          }
          try {
            const sub = await Subject.get(this.profile.subject)
            if (sub && (sub.title || sub.name)) {
              this.formData.department = `Bộ môn ${sub.title || sub.name}`
              return
            }
          } catch (e) {
            console.error('Error fetching subject:', e)
          }
        }
      }

      // Fallback
      if (!this.formData.department) {
        this.formData.department = this.isTeacher ? 'Tổ chuyên môn' : 'Phòng Cơ sở vật chất'
      }
    },
    addItem() {
      this.formData.items.push({
        name: '',
        specifications: '',
        quantity: 1,
        unit: 'Bộ',
        estimatedPrice: 0
      })
    },
    removeItem(index) {
      this.formData.items.splice(index, 1)
    },
    validate() {
      if (this.formData.items.length === 0) {
        this.$alert.error('Vui lòng thêm ít nhất 1 thiết bị cần đề xuất')
        return false
      }
      for (const it of this.formData.items) {
        if (!it.name || !it.name.trim()) {
          this.$alert.error('Vui lòng nhập tên thiết bị cho từng dòng')
          return false
        }
      }
      return this.$refs.form.validate()
    },
    getData() {
      return { ...this.formData }
    },
    resetValidation() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    }
  }
}
</script>
